/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';

interface BlankSlateSignature {
  Element: HTMLDivElement;
  Args: {
    icon: string;
    title: string;
    explanation: string;
    buttonText: string;
    onConnect: () => unknown;
  };
}

export default class BlankSlate extends Component<BlankSlateSignature> {}
